import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import styles from './BadgeList.module.scss';
import ElementList from '../element-list/ElementList';

type VdsBadgePillProps = React.ComponentProps<typeof VdsBadgePill>;

export type BadgeListProps = {
  items: string[];
  statusColor?: VdsBadgePillProps['statusColor'];
};

export const BadgeList = ({ items, statusColor = 'information' }: BadgeListProps): ReactElement => {
  return (
    <ElementList>
      {items.map((item: string, idx: number) => (
        <VdsBadgePill
          key={idx + 1}
          className={styles.badge}
          value={item}
          size="extra-small"
          statusColor={statusColor}
        />
      ))}
    </ElementList>
  );
};

export default BadgeList;
